import React from 'react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { List, ListItem, ListItemButton, ListItemText } from '@mui/material';

import { TooltipIconButton } from '@paragon/client-tools';
import { SharedComponentSet } from '@paragon/contract-library';
import { getClientUrls } from '@paragon/login-tools';
import { Dialog } from '@paragon/popup-state';
import { createScrollbarStyling } from '@paragon/themes';

import { useAppSelector } from '../../hooks';
import { DialogTitleWithBackButton } from './DialogTitleWithBackButton';

interface Props {
  readonly sharedComponentSets: readonly SharedComponentSet[];
  readonly setSharedComponentSet: (sharedComponentSet: SharedComponentSet) => void;

  onNavigationBackRequested: () => void;
}

export function SelectSharedComponentSet({
  sharedComponentSets,
  setSharedComponentSet,
  onNavigationBackRequested,
}: Props) {
  const designUrlForEnvironment = useAppSelector(getClientUrls).designUrl;

  return (
    <Dialog
      variant="design"
      hasTransition={false}
      onCancel="close"
      title={<DialogTitleWithBackButton title="Select Shared Component Set" onBackClick={onNavigationBackRequested} />}
      sx={createScrollbarStyling}
    >
      <List>
        {sharedComponentSets.map((sharedComponentSet) => (
          <ListItem
            key={sharedComponentSet.lookupCode}
            disablePadding
            secondaryAction={
              <TooltipIconButton
                enableInteractive
                title={'Open in new tab'}
                onClick={() => void window.open(`${designUrlForEnvironment}${sharedComponentSet.lookupCode}`, '_blank')}
              >
                <OpenInNewIcon />
              </TooltipIconButton>
            }
          >
            <ListItemButton
              key={sharedComponentSet.lookupCode}
              onClick={() => void setSharedComponentSet(sharedComponentSet)}
            >
              <ListItemText
                primary={sharedComponentSet.name}
                secondary={`Created: ${Intl.DateTimeFormat('en-US', { dateStyle: 'short', timeStyle: 'short' }).format(new Date(sharedComponentSet.created))}`}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
}
